import Typography from './overrides/Typography';
import Palette from './overrides/Palette';
import { Theme, createTheme } from '@mui/material';
import { AppTheme, DefaultTheme } from 'state/baseapplication/Reducer';

const theme = (appTheme: AppTheme = DefaultTheme): Theme =>
    createTheme({
        spacing: 4,
        palette: Palette(appTheme),
        typography: Typography,
        components: {
            MuiFormControl: {
                styleOverrides: {
                    root: {
                        marginBottom: 20,
                    },
                },
            },
            MuiTypography: {},
            MuiOutlinedInput: {
                styleOverrides: {
                    root: {},
                },
            },
            MuiFormLabel: {
                styleOverrides: {
                    root: {
                        color: '#9F9F9F',
                    },
                },
            },
            MuiCheckbox: {
                styleOverrides: {
                    root: {
                        color: '#9F9F9F',
                    },
                },
            },
            MuiDialog: {
                styleOverrides: {
                    paper: {
                        backgroundColor: '#ffffff',
                        borderRadius: '10px',
                    },
                },
            },
            MuiPopover: {
                styleOverrides: {
                    paper: {
                        backgroundColor: '#1C2022',
                    },
                },
            },
            MuiListItem: {
                styleOverrides: {
                    root: {},
                },
            },
            MuiMenu: {
                styleOverrides: {
                    paper: { backgroundColor: '#ffffff' },
                },
            },

            MuiListItemText: {
                styleOverrides: {
                    root: {
                        // color: "#ffffff",
                    },
                },
            },
            MuiListItemIcon: {
                styleOverrides: {
                    root: {
                        minWidth: '40px',
                    },
                },
            },
            MuiDrawer: {
                styleOverrides: {
                    paper: {
                        backgroundColor: '#171717',
                        borderRadius: '20px',
                        border: '1px solid #1C2022',
                    },
                },
            },
            MuiAvatar: {
                styleOverrides: {
                    root: {},
                    square: {},
                    img: {},
                    colorDefault: {
                        backgroundColor: '#1c2022',
                    },
                },
            },
            MuiTooltip: {
                styleOverrides: {
                    tooltip: {
                        backgroundColor: '#1c2022',
                        padding: '20px',
                    },
                },
            },
            MuiLinearProgress: {
                styleOverrides: {
                    colorPrimary: {
                        color: '#ffe57a',
                        backgroundColor: '#eef0f5',
                    },
                },
            },
        },
    });

export default theme;
